// @ts-check
import {createBrowserHistory} from "history"

/** Browser history singleton. */
export default createBrowserHistory()
